import { cloneObj, compare, Module } from '@nu-art/ts-common';
import { dispatch_OnProtocolInteraction } from './dispatcher.js';
import { ProtocolInteractionType_AddOrder } from '@app/advisor-v5-shared';
import { ModuleFE_Inbox } from '../../modules/module-inbox/ModuleFE_Inbox.js';
import { ModuleFE_Spotlight } from '../../modules/ModuleFE_Spotlight/index.js';
class ModuleFE_ProtocolInteraction_Class extends Module {
    currentInteraction;
    dispositionData;
    __onAdvisorReset() {
        this.clearInteraction();
    }
    // ######################### Internal Logic #########################
    setInteraction = (interaction) => {
        //No need to set interaction if it's equal to the current, if in nav mode dispatching the event again is needed!
        if (compare(interaction, this.currentInteraction))
            return;
        //Don't set interaction that needs a protocol id but doesn't have one
        if (!interaction?.protocolId)
            return;
        //Set interaction and dispatch
        this.currentInteraction = interaction;
        dispatch_OnProtocolInteraction.dispatchUI();
    };
    clearInteraction = () => {
        if (!this.currentInteraction)
            return;
        delete this.currentInteraction;
        dispatch_OnProtocolInteraction.dispatchUI();
    };
    // ######################### Public Methods - Protocol Interaction #########################
    getInteraction = () => this.currentInteraction ? cloneObj(this.currentInteraction) : undefined;
    getFocusedProtocolId = () => {
        return this.currentInteraction?.protocolId;
    };
    openAddOrder = (protocolId) => {
        this.setInteraction({
            type: ProtocolInteractionType_AddOrder,
            protocolId,
        });
    };
    // ######################### Public Methods - Disposition Interaction #########################
    getDispositionData = () => this.dispositionData ? cloneObj(this.dispositionData) : undefined;
    openDisposition = (type, protocolId, additionalProtocolIds) => {
        const data = { type, protocolId };
        if (compare(this.dispositionData, data))
            return;
        this.dispositionData = data;
        dispatch_OnProtocolInteraction.dispatchUI();
        ModuleFE_Inbox.setSelectedInboxItem();
        return ModuleFE_Spotlight.openDisposition({ dispositionType: type, protocolId, additionalProtocolIds });
    };
    closeDisposition = (closeSpotlight = false) => {
        if (!this.dispositionData)
            return;
        delete this.dispositionData;
        dispatch_OnProtocolInteraction.dispatchUI();
        if (closeSpotlight) {
            ModuleFE_Spotlight.closeSpotlight();
        }
    };
    closeInteraction = () => {
        this.clearInteraction();
    };
}
export const ModuleFE_ProtocolInteraction = new ModuleFE_ProtocolInteraction_Class();
//# sourceMappingURL=ModuleFE_ProtocolInteraction.js.map